import { Text, View } from 'react-native';
import DefaultScreen from '../../../components/Global/DefaultScreenView';
import AnimatedLottieView from '@utils/lottieAnimation';
import React from 'react';
const ComingSoonScreen = () => {
  return (
    <DefaultScreen screenTitle={'Coming Soon'}>
      <AnimatedLottieView source={require('@assets/animations/113096-coming-soon.json')} style={{ width: '100%' }} autoPlay loop={false} />
      <Text adjustsFontSizeToFit style={{ alignContent: 'center', alignItems: 'center', alignSelf: 'center', margin: 20, fontSize: 17 }}>This feature is coming soon! 😁 </Text>
    </DefaultScreen>
  )
}
export default ComingSoonScreen;